module.exports = __webpack_public_path__ + "static/media/areas03.7042afe4.jpg";